module.exports = __webpack_public_path__ + "onboarding-pkg-dotnetpack.2ed4a1f99186b5b4f38cbda923090183.hashedasset.svg";